<template>
    <div class="col-12">
        <h2 class="card-title">Agents</h2>
        <card>
            <div class="row">

                <div class="col-md-12 col-12 mb-auto">



                    <el-table header-cell-class-name="table" header-row-class-name="table-transparent"
                        row-class-name="table-transparent" :data="agencies">
                        <el-table-column min-width="150" sortable label="Profile Picture"
                            property="agents.agency_details.profile_path">
                            <template slot-scope="scope">
                                <img v-if="scope.row.profile_path" class="card-img-top"
                                    :src="scope.row.profile_path" alt="Agent Image Profile"
                                    :style="{ maxWidth: '150px', maxHeight: '130px' }" />
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150" sortable label="Agency Name"
                            property="agency_name"></el-table-column>
                        <el-table-column min-width="150" sortable label="Contact Person">
                            <template slot-scope="scope">
                                <span> {{ scope.row.first_name + " " + scope.row.last_name }} </span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150" sortable label="Phone Number"
                            property="agency_details.mobile"></el-table-column>
                        <el-table-column min-width="150" sortable label="Email" property="email">
                        </el-table-column>
                        <el-table-column min-width="150" sortable label="Action">
                            <div slot-scope="scope" class="">
                                <a @click="changeAgentStatus(scope.row.user_id, 'active')" class="btn btn-primary"
                                    v-if="scope.row.active == 0">Approve</a>

                                <a @click="changeAgentStatus(scope.row.user_id, 'inactive')" class="btn btn-danger"
                                    v-else>Reject</a>
                            </div>
                        </el-table-column>



                    </el-table>




                </div>
            </div>

            <!-- Classic Modal -->

        </card>
    </div>
</template>

<script>


import { Option, Table, TableColumn } from 'element-ui';
import { TabPane, Tabs, Modal } from 'src/components';
import { api_url } from '../../env';

export default {
    name: "ManageAgents",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            agencies: []
        };
    },
    methods: {

        getAgencies() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/agents', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {

                            //steps
                            //1. Get all the data and prep it
                            response.agents.forEach(agent => {
                                let location_details = (agent.location_details) ? JSON.parse(agent.location_details) : null
                                let agency_details = (agent.agency_details) ? JSON.parse(agent.agency_details) : null
                                let payment_details = (agent.payment_details) ? JSON.parse(agent.payment_details) : null

                                //2 . Prep it
                                agent.location_details = location_details
                                agent.agency_details = agency_details
                                agent.payment_details = payment_details

                            });


                            //3. Assign it to this.model
                            this.agencies = response.agents


                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                },
                )
        },

        changeAgentStatus(id, status) {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.post(api_url + '/admin/user/changeStatus?user_id=' + id + '&status=' + status, { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                }).then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            this.models = response.models
                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                })

        },

        alertNotification(verticalAlign, horizontalAlign, color, message) {
            this.$notify({
                message: message,
                timeout: 30000,
                icon: 'tim-icons icon-bell-55',
                horizontalAlign: horizontalAlign,
                verticalAlign: verticalAlign,
                type: color
            });
        },
    },
    created() {
        this.getAgencies()

    }

}

</script>
<style>
.el-table th.el-table__cell {
    overflow: hidden;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #1e1e2c;
}
</style>
<style scoped>
.form-control {
    color: #000;
}

.modal {
    top: -150px;
}

@media screen and (min-width:800px) {
    .modal-dialog {
        max-width: 800px;
    }
}
</style>